import cn from 'classnames'
import { text_colorTextPrimary } from 'ext-ui/style/colors'
import ArrowIcon from 'ext-ui/svg/icon/ArrowIcon'
import React, { ComponentProps, ReactElement } from 'react'

import style from './LargePill.style'

export type LargePillProps = {
  title: string
  subtitle?: string
  icon?: React.ReactElement
  onClick?: () => void
  className?: string
} & ComponentProps<'div'>

function LargePill(props: LargePillProps): ReactElement {
  const {
    title,
    subtitle,
    icon = <ArrowIcon fill={text_colorTextPrimary} direction={'up-right'} />,
    onClick,
    className = '',
    ...rest
  } = props

  return (
    <div
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyUp={(e): void => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
          onClick()
        }
      }}
      className={cn('LargePill', className, {
        interactable: onClick !== undefined,
      })}
      css={style}
      {...rest}
    >
      <div className={'flex-column gap-1'}>
        <div className={'font-bold'}>{title}</div>
        {subtitle && <div className={'font-regular'}>{subtitle}</div>}
      </div>
      <div className={'icon-wrapper'}>{icon}</div>
    </div>
  )
}

export default LargePill
